import { Locale, format } from 'date-fns';
import { i18n } from 'i18next';

import { InterviewSchedulerView } from 'constants/enums';

import { INTERVIEW_SLOT_TIME_PATTERN } from '../utils/interviewSlotFormatting';

export const MAX_SLOTS = 7;
export const MIN_HOUR = 9;
export const MAX_HOUR = 18;
export const DAYS_AHEAD = 21;

/** Week/day column headers: weekday on first line, month + day on second (react-big-calendar uses `dayFormat` here). */
const weekDayColumnHeaderLabel = (date: Date, locale: Locale) =>
  `${format(date, 'EEEE', { locale })}\n${format(date, 'MMMM d', { locale })}`;

export const getCalendarFormats = (
  locale: Locale,
  compactWeekdayNames = false
) => ({
  timeGutterFormat: (date: Date) =>
    format(date, INTERVIEW_SLOT_TIME_PATTERN, { locale }),
  eventTimeRangeFormat: ({ start, end }: { start: Date; end: Date }) =>
    `${format(start, INTERVIEW_SLOT_TIME_PATTERN, { locale })} – ${format(end, INTERVIEW_SLOT_TIME_PATTERN, { locale })}`,
  dayHeaderFormat: (date: Date) => weekDayColumnHeaderLabel(date, locale),
  dayRangeHeaderFormat: ({ start, end }: { start: Date; end: Date }) =>
    `${format(start, 'EEEE d', { locale })} – ${format(end, 'EEEE d', { locale })}`,
  dayFormat: (date: Date) => weekDayColumnHeaderLabel(date, locale),
  /** Month view top row: weekday label only (`EEE` on mobile, full name on desktop). */
  weekdayFormat: (date: Date) =>
    format(date, compactWeekdayNames ? 'EEE' : 'EEEE', { locale }),
  monthHeaderFormat: (date: Date) => format(date, 'MMMM yyyy', { locale })
});

export const getCalendarMessages = (i18nInstance: i18n) => ({
  showMore: (total: number) => i18nInstance.t('calendar.showMore', { total })
});

export const calendarSettings = {
  step: 60,
  timeslots: 1,
  defaultMobileView: InterviewSchedulerView.Day,
  defaultDesktopView: InterviewSchedulerView.Month,
  mobileViews: [InterviewSchedulerView.Day, InterviewSchedulerView.Month],
  desktopViews: [InterviewSchedulerView.Week, InterviewSchedulerView.Month],
  longPressThresholdMobile: 50,
  longPressThresholdDesktop: 250,
  mobileClickDelay: 300
};

export enum NavigationAction {
  Prev = 'PREV',
  Today = 'TODAY',
  Next = 'NEXT'
}
